import { combineReducers } from 'redux';
import appReducer from './appReducer';
import adminReducer from './adminReducer';

export default combineReducers({
  app_reducer: appReducer,
  admin_reducer: adminReducer
});
